<template>
  <div class="order-select white-bg">
    <el-form>
      <el-row
        :gutter="20"
        class="page-query-content">
        <el-col :xs="24" :sm="12" :md="8" :lg="8">
          <el-form-item
            label="商户"
          >
            <el-select
              v-model="merchantCode"
              clearable
              placeholder="请选择"
              class="vsselect"
              @change="toQuery"
            >
              <el-option
                v-for="(item,index) in merchantCodeList"
                :key="index"
                :label="item.merName"
                :value="item.merCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8">
          <el-form-item label="支付状态">
            <el-select
              v-model="payStatus"
              clearable
              placeholder="请选择"
              class="vsselect"
              @change="toQuery"
            >
              <el-option
                v-for="(item,index) in payStatusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8">
          <el-form-item label="订单时间">
            <el-date-picker
              v-model="orderDate"
              type="daterange"
              class="vsselect"
              placeholder="请选择"
              @change="toQuery"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

  </div>
</template>

<script>
  import  selectQuery from '@/mixins/selectQuery'
  import { queryValidMerchants } from '@/api/merchan'
  import { queryValidProducts } from '@/api/product'
  import { queryValidChannels } from '@/api/channel'
  export default {
    name: "querySelect",
    data() {
      return {
        merchantCodeList: [],

        channelCodeList: [],

        merchantCode: '',
        channelCode: '',
        payStatus: '',
        orderDate: [],
        payStatusList: [
          {
            label: '未支付',
            value: 201,
          },
          {
            label: '支付成功',
            value: 202,
          },
          {
            label: '支付失败',
            value: 203,
          },
          {
            label: '支付中',
            value: 204,
          },
          {
            label: '已过期',
            value: 205,
          },
          {
            label: '转账退款',
            value: 206,
          }
        ],


      }
    },
    created(){
      this.getMerchantCodeList();
      this.getChannelList();
    },
    mixins: [selectQuery],
    methods: {
      getMerchantCodeList() {
        queryValidMerchants().then((res) => {
          console.log(res);
          this.merchantCodeList = res.data;
        });
      },
      getChannelList() {
        queryValidChannels().then((res) => {
          console.log(res);
          this.channelCodeList = res.data.content;
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .vsselect {
    width: 100%;
    margin-bottom: 10px;
  }
</style>
